import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UiIcon } from 'ui-components';
import {
  StyledExportTypeItem,
  StyledExportTypeStep,
} from './ExportTypeStep.styles';

const ExportTypeIcon = ({ type }) => {
  const config = {
    excel: {
      color: '#099250',
      text: 'XLSX',
    },
    bulletin: {
      color: '#444CE7',
      text: 'B',
    },
  }[type];

  return (
    <svg
      width='48'
      height='60'
      viewBox='0 0 48 60'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 4C0 1.79086 1.79086 0 4 0H30L48 18V56C48 58.2091 46.2091 60 44 60H4C1.79086 60 0 58.2091 0 56V4Z'
        fill={config.color}
      />
      <path
        opacity='0.3'
        d='M30 0L48 18H34C31.7909 18 30 16.2091 30 14V0Z'
        fill='white'
      />
      <text
        x='24'
        y='38'
        textAnchor='middle'
        fill='white'
        fontSize='12'
        fontWeight='bold'
      >
        {config.text}
      </text>
    </svg>
  );
};

ExportTypeIcon.propTypes = {
  type: PropTypes.oneOf(['excel', 'bulletin']).isRequired,
};

const ExportTypeStep = ({
  onTypeSelect,
  showExcel = true,
  showBulletin = true,
}) => {
  const { t } = useTranslation();

  const exportTypes = [
    showExcel && {
      value: 'excel',
      label: t('content:exportType.excel.label'),
      description: t('content:exportType.excel.description'),
    },
    showBulletin && {
      value: 'bulletin',
      label: t('content:exportType.bulletin.label'),
      description: t('content:exportType.bulletin.description'),
    },
  ].filter(Boolean);

  return (
    <StyledExportTypeStep className='export-type-step'>
      <div className='content-export-type-subtitle'>
        {t('content:exportType.choose')}
      </div>
      <div className='export-type-step-container'>
        {exportTypes.map((exportType) => (
          <StyledExportTypeItem
            key={exportType.value}
            onClick={() => onTypeSelect(exportType.value)}
            data-testid={`content-export-type-${exportType.value}`}
          >
            <div className='format-item-container'>
              <div className='label'>
                <ExportTypeIcon type={exportType.value} />
                <div className='format-title'>
                  <span className='label-title'>{exportType.label}</span>
                  <UiIcon icon='ri-arrow-left-line' color='#0C395A' size={16} />
                </div>
              </div>
              <div className='format-item-description'>
                {exportType.description}
              </div>
            </div>
          </StyledExportTypeItem>
        ))}
      </div>
    </StyledExportTypeStep>
  );
};

ExportTypeStep.propTypes = {
  onTypeSelect: PropTypes.func.isRequired,
  showExcel: PropTypes.bool,
  showBulletin: PropTypes.bool,
};

export default ExportTypeStep;
